<template>
  <div>
    <el-card class="box-card">
      <DeviceDetail ref="deviceDetail" :lgid="lgid"></DeviceDetail>
    </el-card>
    <el-tabs type="border-card" tabPosition="top">
      <el-tab-pane label="周期任务记录">
        <PeriodTaskRd ref="periodTaskRd" :lgid="lgid"></PeriodTaskRd>
      </el-tab-pane>
      <el-tab-pane label="即时任务记录">
        <RealtimeTaskRd ref="realtimeTaskRd" :lgid="lgid"></RealtimeTaskRd>
      </el-tab-pane>
      <el-tab-pane label="黑电台记录">
        <BlacklistRd ref="blacklistRd" :lgid="lgid"></BlacklistRd>
      </el-tab-pane>
      <el-tab-pane label="电台录音记录">
        <AudioRd ref="audioRd" :lgid="lgid"></AudioRd>
      </el-tab-pane>
      <el-tab-pane label="现场维护记录">
        <DeviceMaintainRd ref="deviceMaintainRd" :lgid="lgid"></DeviceMaintainRd>
      </el-tab-pane>
      <el-tab-pane label="心跳记录">
        <HeartbeatRd ref="heartbeatRd" :lgid="lgid"></HeartbeatRd>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import DeviceDetail from "@/components/Form/DeviceDetail";
  import PeriodTaskRd from "@/components/Tables/PeriodTaskRd";
  import RealtimeTaskRd from "@/components/Tables/RealtimeTaskRd";
  import BlacklistRd from "@/components/Tables/BlacklistRd";
  import AudioRd from "@/components/Tables/AudioRd";
  import HeartbeatRd from "@/components/Tables/HeartbeatRd";
  import DeviceMaintainRd from "@/components/Tables/DeviceMaintainRd";
  export default {
    props: [],
    mounted() {
      this.dealurl(this.$route.params);
      // // 刷新组件数据 
      // // 但是在vue的mounted钩子中直接用 $ref 访问子组件得到的结果是undefined
      // // 因此使用setTimeout，延后到mounted之后可成功执行
      // setTimeout(() => {
      //   if (this.$refs["deviceDetail"]) {
      //     this.$refs["deviceDetail"].getData();
      //   }
      //   if (this.$refs["periodTaskRd"]) {
      //     this.$refs["periodTaskRd"].getData();
      //   }
      // }, 0);
    },
    methods: {
      dealurl(params) {
        this.lgid = params.lgid;
      }
    },
    components: {
      DeviceDetail,
      PeriodTaskRd,
      RealtimeTaskRd,
      BlacklistRd,
      AudioRd,
      HeartbeatRd,
      DeviceMaintainRd
    },
    data() {
      return {
        lgid: null
      };
    }
  };

</script>
<style scoped>
  .el-card {
    margin-bottom: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/DeviceInfo.vue